import { URLParamKey } from 'constants/urlParams'
import { TestType } from 'types/testType'

/** Default URL query param values applied per test type when missing from the URL. */
export const TEST_TYPE_URL_DEFAULTS: Record<TestType, Record<string, string>> = {
  [TestType.FOB]: {
    [URLParamKey.TEST_TYPE]: TestType.FOB,
  },
  [TestType.HPYLORI]: {
    [URLParamKey.TEST_TYPE]: TestType.HPYLORI,
  },
}
